import { Box, Typography } from "@mui/material";
import { colors, eyebrowSx, fonts } from "../../../theme/designTokens";

export default function PageHeader({ title, eyebrow, action }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        mb: 3,
      }}
    >
      <Box>
        {eyebrow && <Box sx={eyebrowSx}>{eyebrow}</Box>}
        <Typography
          component="div"
          sx={{
            fontFamily: fonts.display,
            fontWeight: 800,
            fontSize: "1.4rem",
            color: colors.ink,
            mt: eyebrow ? 1 : 0,
          }}
        >
          {title}
        </Typography>
      </Box>
      {action && <Box>{action}</Box>}
    </Box>
  );
}
